<template>
	<div class="filter-with-without-type">
		<div>
            <!-- RADIO : mode => mode -->
			<template v-for="option in optionsMode">
				<div class="form-group" :key="option.value">
					<label class="form-label label-auto" :for="'opt-'+option.value">
						<input type="radio" name="options" :id="'opt-'+option.value" v-model="mode" :value="option.value" />
						{{ option.label }}
					</label>
				</div>
			</template>

            <!-- SELECT : choice => type -->
            <template class="form-group" v-if="hasMultipleType">
                <h4 v-html="filter.inputs.type.label"></h4>
                <el-select :class="`wp-10 ` + {'is-disabled-input' : isActive}" 
                    :disabled="isActive"
                    filterable v-model="choice" 
                    :multiple="filter.inputs.type.multiple">
                    <el-option v-for="option in optionsType" 
                        :key="'opt-type-'+option.label" 
                        :label="option.label"
                        :value="option.value">
                        {{ option.label }}
                    </el-option>
                </el-select>
            </template>

            <!-- SELECT : subChoices => statuses -->
            <template class="form-group">
                <h4 v-html="filter.inputs.statuses.label"></h4>
                <el-cascader :class="`wp-10 ` + {'is-disabled-input' : isActive}"
                             :disabled="isActive || !choice" 
                             v-model="subChoices" 
                             popper-class="custom-dropdown"
                             :visible-arrow="false"
                             :props="propsOpt(filter.inputs.statuses)" 
                             :options="optionsStatuses(choice)" />
            </template>
		</div>
	</div>
</template>
<script>
	import ListingFilterMixin from './ListingFilterMixin.js';

	export default{
		mixins	: [
			ListingFilterMixin
		],
        props: {
            filter: {
                type: Object,
                required: true
            }
        },
		data () {
			return {
				mode : '',
				choice : '',
				subChoices : [],
			}
		}, 
        watch: {
          choice: function(newChoice, oldChoice) {
              if (newChoice !== oldChoice && oldChoice !== '' && oldChoice !== undefined)  {
                  this.subChoices = []
              }
          }  
        },
		computed : {
			data (){
				return {
					mode : this.mode,
					choice : this.choice,
					subChoices : this.formatSubChoices
				};
            },

            formatSubChoices(){
                let choices = [];
                this.subChoices.forEach(choice => {
                    choice = Array.isArray(choice) ? choice[0] : choice
                    choices.push(choice)
                })
                return choices;
            },

            /**
             * If "with"
             */
            isActive(){
                return (this.mode !== 'with')
            },
            optionsMode(){
                let options = this.filter.inputs.mode.options;
                return Object.values(options);
            },

            /**
             * add value in the options list of "type"
             * return {*}
             */
            optionsType(){
                let options = this.filter.inputs.type.options;
                for (const [name , option] of Object.entries(options)){
                    option.value = name;
                }
                return options;
            },

            /**
             * Define if filter has multiple type. If single, this one is the selected by default
             * return boolean : true if has multiple type else false
             */
            hasMultipleType(){
                let options = Object.keys(this.filter.inputs.type.options)
                if(options.length > 1){
                    return true
                }
                this.choice = options[0];
                return false
            },
		},
        methods: {

            propsOpt(option){
                const propOption = {
                    multiple : (option.multiple ? option.multiple : false),
                    filterable : (option.filterable ? option.filterable : false)
                }
                return propOption;
            },
            /**
             * put a list only the list of choice of the selected "type"
             * return {*}
             */
            optionsStatuses(choice){
                let optList = [];

                if(choice){
                    const list = Object.entries(this.filter.inputs.type.options).find(optChoice => optChoice[0] === choice);
                    for (const [value, label] of Object.entries(list[1].choices)){
                        optList.push({value : value , label : label})
                    }
                } 
                return optList;
            },
        }

	}
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';

.filter-with-without-type {
    .el-cascader__tags {
        .el-tag.el-tag--info.el-tag--small.el-tag--light {
            color: $gray-100;
            background-color: $primary-05;
            
            .el-tag__close.el-icon-close {
                background-color: #CCCCD1;
            }
        }
    }
}
.el-popper.el-cascader__dropdown.custom-dropdown {
    box-shadow: 0 0 12px rgba(17, 17, 17, 0.24);
    border-radius: 6px;
    margin-top: 4px !important;
    .el-select-dropdown__list {
        padding: 8px 0;

        .el-select-dropdown__item {
            border-radius: 4px;
            margin: 0 8px;
            padding: 0 8px;
        }
    }

    .el-cascader-panel {
        .el-scrollbar.el-cascader-menu .el-cascader-menu__wrap.el-scrollbar__wrap {
            color: $gray-100;
            height: auto;
            .el-cascader-node:hover {
                background: #EDF0FF;
            }
        }
    }
}
</style>